/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://5cmxnkw4e5c67e6le7fxfqbyzq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-2u7hzaftsvdblplar7cxkz5dku",
    "aws_cognito_identity_pool_id": "us-east-1:4aa87eba-2f87-403a-b566-81eb9b071390",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_X3TNzAnNW",
    "aws_user_pools_web_client_id": "7gkjkq0o8gv9lktdk0vuoagm05",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "camino-pro-react44356-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
